import { clsx as e } from "clsx";
import { twMerge as t } from "tailwind-merge";
//#region src/lib/utils.ts
function n(...n) {
	return t(e(n));
}
//#endregion
export { n as cn };

//# sourceMappingURL=utils.js.map